/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_ConnectingInputs */

const en_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to Iconik...`)
};

const fr_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion a Iconik...`)
};

const de_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zu Iconik wird hergestellt...`)
};

const it_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione a Iconik...`)
};

const ru_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключение к Iconik...`)
};

const es_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando a Iconik...`)
};

const zh_cn2_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在连接到 Iconik...`)
};

const ja_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik に接続しています...`)
};

const hi_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik से कनेक्ट हो रहा है...`)
};

const pt_pt2_iconik_proxy_status_connecting = /** @type {(inputs: Iconik_Proxy_Status_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectando-se à Iconik...`)
};

/**
* | output |
* | --- |
* | "Connecting to Iconik..." |
*
* @param {Iconik_Proxy_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_connecting = /** @type {((inputs?: Iconik_Proxy_Status_ConnectingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_ConnectingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_proxy_status_connecting(inputs)
	if (locale === "de") return de_iconik_proxy_status_connecting(inputs)
	if (locale === "it") return it_iconik_proxy_status_connecting(inputs)
	if (locale === "ru") return ru_iconik_proxy_status_connecting(inputs)
	if (locale === "es") return es_iconik_proxy_status_connecting(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_proxy_status_connecting(inputs)
	if (locale === "ja") return ja_iconik_proxy_status_connecting(inputs)
	if (locale === "hi") return hi_iconik_proxy_status_connecting(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_proxy_status_connecting(inputs)
	return en_iconik_proxy_status_connecting(inputs)
});